import type { FaireProductEntity } from "../../entity_types/product";

export const p_jgdhwv9hr2: FaireProductEntity = {
  token: "p_jgdhwv9hr2",
  type: "product",
  name: "365 Bible Stories and Prayers Religious Keepsake Book",
  brandToken: "b_75qtacjqim",
  brandName: "Cottage Door Press",
  imageUrl:
    "https://cdn.faire.com/fastly/5fbe48c9e67a5eb3812d13d23e1963642dde0e8cb5646242156f8c59b303b3ad.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3359cdb297ae8f247788e3118ad394be6388c776472835e26459a9f1338dc449.jpeg",
    "https://cdn.faire.com/fastly/86dadca7efe15f175a6fb6ac10658642ec24a65d99eeaa82c4330729b7326acf.jpeg",
  ],
  priceDollars: 12.09,
  description:
    "\nDiscover the love of Christ with your children every day of the year through inspirational readings, bright illustrations, and a selection of traditional and original prayers. Share adaptations of favorite Bible stories like Noah building an ark to survive the flood, how David defeats Goliath, Jesus's story from birth to betrayal to resurrection, and everything in between. Mix a sweet prayer into the daily routine of reading from the Cottage Door Press children's Bible to give thanks to God for our wonderful world, family and friends, or to ask for guidance. This sturdy padded board book is a wonderful introduction to faith for kids of all ages, boy or girl, and a perfect addition to the family library of Christian books!",
  tags: [],
  msrpDollars: 23.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:45.616Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
